// extracted by mini-css-extract-plugin
export default {"wrapper":"AppError_wrapper__9sOU5"};